import { render, staticRenderFns } from "./LabelDropdownItem.vue?vue&type=template&id=b89598bc&scoped=true"
import script from "./LabelDropdownItem.vue?vue&type=script&lang=js"
export * from "./LabelDropdownItem.vue?vue&type=script&lang=js"
import style0 from "./LabelDropdownItem.vue?vue&type=style&index=0&id=b89598bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89598bc",
  null
  
)

export default component.exports